import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";

const WorkshopSupplierForm = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/workshop-suppliers";

  const [formData, setFormData] = useState({
    name: "",
    contact_person: "",
    phone: "",
    email: "",
    address: "",
  });

  const isUpdateMode = !!initialData;

  const { createData: createSupplier } = useCreateData(
    API_URL,
    "workshop-suppliers"
  );
  const { updateData: updateSupplier } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "workshop-suppliers"
  );

  const handleChange = useFormChangeHandler(setFormData);

  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateSupplier : createSupplier,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
    };

    handleSubmit(payload, e);
  };

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...initialData,
      });
    }
  }, [initialData]);

  return (
    <form
      onSubmit={(e) => handleBeforeSubmit(e)}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="name"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Name :
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.name && "is-invalid"
              )}
              id="name"
              placeholder="Supplier Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.name && (
              <div className="invalid-feedback">{formError.name}</div>
            )}
          </div>
        </div>

        <div className="row mb-3 align-items-center">
          <label
            htmlFor="contact_person"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Contact Person :
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.contact_person && "is-invalid"
              )}
              id="contact_person"
              placeholder="Contact Person"
              name="contact_person"
              value={formData.contact_person}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.contact_person && (
              <div className="invalid-feedback">{formError.contact_person}</div>
            )}
          </div>
        </div>

        <div className="row mb-3 align-items-center">
          <label
            htmlFor="phone"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Phone :
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.phone && "is-invalid"
              )}
              id="phone"
              placeholder="Phone Number"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.phone && (
              <div className="invalid-feedback">{formError.phone}</div>
            )}
          </div>
        </div>

        <div className="row mb-3 align-items-center">
          <label
            htmlFor="email"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Email :
          </label>
          <div className="col-sm-8">
            <input
              type="email"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.email && "is-invalid"
              )}
              id="email"
              placeholder="Email Address"
              name="email"
              value={formData.email}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.email && (
              <div className="invalid-feedback">{formError.email}</div>
            )}
          </div>
        </div>

        <div className="row mb-3 align-items-center">
          <label
            htmlFor="address"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Address :
          </label>
          <div className="col-sm-8">
            <textarea
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.address && "is-invalid"
              )}
              id="address"
              placeholder="Address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              disabled={isSubmitting}
              rows="3"
              style={{ fontSize: "14px" }}
            />
            {formError?.address && (
              <div className="invalid-feedback">{formError.address}</div>
            )}
          </div>
        </div>
      </div>

      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode ? "Update" : "Create"}
        </button>
      </div>
    </form>
  );
};

export default WorkshopSupplierForm;
